import React from "react";
import { DateRangePicker } from "rsuite";
import { Typography, Box } from "@mui/material";
import { useFormikContext, getIn } from "formik";
import { getDateFormat, getDateFormatForDatePicket } from "helper/dateFormat";

// direct import
import "./style.scss";
import "rsuite/dist/rsuite.min.css";

const DateRangePickerField = ({ name, title, mandatory, ...props }) => {
  const { values, setFieldValue, errors, touched } = useFormikContext();

  const dateFormat = getDateFormatForDatePicket();
  const placeholderFormat = getDateFormat();

  const value = getIn(values, name);
  const error = getIn(errors, name);
  const isTouched = getIn(touched, name);

  return (
    <Box className="date-range-wrapper">
      {title && (
        <Typography className="date-range-title">
          {title}
          {mandatory && <span style={{ color: "red", fontSize: 15 }}> *</span>}
        </Typography>
      )}

      <DateRangePicker
        {...props}
        value={value || null}
        format={dateFormat}
        placeholder={`${placeholderFormat} ~ ${placeholderFormat}`}
        onChange={(val) => setFieldValue(name, val)}
        onKeyPress={(event) => {
          if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
          }
        }}
        cleanable
        size="lg"
        style={{
          display: "inline-block",
          padding: "0",
          border: "0",
          width: "100%",
          color: "black",
        }}
      />
      {isTouched && error ? (
        <Box style={{ color: "red", fontSize: 12, marginTop: 4 }}>{error}</Box>
      ) : null}
    </Box>
  );
};

export default DateRangePickerField;
